import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "bg-primary-25 flex flex-col text-left justify-center px-4 text-gray-900 text-base font-medium",
    style: { "height": "52px" }
};
const _hoisted_2 = {
    style: { "height": "498px" },
    class: "overflow-y-scroll flex flex-col space-y-3 py-2"
};
const _hoisted_3 = { class: "flex flex-col space-y-2" };
const _hoisted_4 = { class: "text-md font-medium text-gray-700 px-3" };
const _hoisted_5 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_6 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_7 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_8 = { class: "w-40 flex items-center" };
const _hoisted_9 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_10 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_11 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_12 = { class: "w-40 flex items-center" };
const _hoisted_13 = { class: "text-md font-medium text-gray-700 px-3 pt-3" };
const _hoisted_14 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_15 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_16 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_17 = { class: "w-40 flex items-center" };
const _hoisted_18 = { class: "text-md font-medium text-gray-700 px-3 pt-3" };
const _hoisted_19 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_20 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_21 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_22 = { class: "w-40 flex items-center" };
import fabric from '@/compositions/useFabricObject';
import { UIDivider, UIInputNumber, UISlider } from '@gohighlevel/ghl-ui';
import { computed, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdjustmentsTool',
    props: {
        canvasCtx: {
            type: Object,
            require: true,
        },
        bgImage: {
            type: Object,
            require: true,
        },
        reset: {
            type: Boolean,
            require: true,
        },
    },
    emits: ['fabricChange'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const brightness = ref(0);
        const contrast = ref(0);
        const shadows = ref(0);
        const saturation = ref(0);
        const temperature = ref(0);
        const clarity = ref(0);
        const blur = ref(0);
        const isReset = computed(() => props.reset);
        const f = fabric.Image.filters;
        watch(brightness, () => {
            if (isNaN(brightness.value))
                return;
            const brightnessFilter = new f.Brightness({
                brightness: brightness.value / 100,
            });
            applyFilter(5, brightnessFilter);
        });
        watch(contrast, () => {
            if (isNaN(contrast.value))
                return;
            const contrastFilter = new f.Contrast({
                contrast: contrast.value / 100,
            });
            applyFilter(6, contrastFilter);
        });
        watch(saturation, () => {
            if (isNaN(saturation.value))
                return;
            const saturationFilter = new f.Saturation({
                saturation: saturation.value / 100,
            });
            applyFilter(7, saturationFilter);
        });
        watch(blur, () => {
            if (isNaN(blur.value))
                return;
            const blurFilter = new f.Blur({
                blur: blur.value / 100,
            });
            applyFilter(11, blurFilter);
        });
        watch(isReset, () => {
            if (!isReset.value)
                return;
            brightness.value = 0;
            contrast.value = 0;
            shadows.value = 0;
            saturation.value = 0;
            temperature.value = 0;
            clarity.value = 0;
            blur.value = 0;
        });
        function applyFilter(index, filter) {
            try {
                const obj = props.canvasCtx.item(0);
                if (obj) {
                    obj.filters[index] = filter;
                    obj.applyFilters();
                    props.canvasCtx.renderAll();
                    emits('fabricChange');
                }
            }
            catch (error) {
                // error to be handle
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('adjustments.title')), 1),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('adjustments.light.title')), 1),
                        _createVNode(_unref(UIDivider)),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('adjustments.light.brightness')), 1),
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(_unref(UIInputNumber), {
                                    id: "media-editor-adjustments-brightness-input",
                                    size: "medium",
                                    value: brightness.value,
                                    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((brightness).value = $event)),
                                    style: { "width": "58px" },
                                    min: -100,
                                    max: 100,
                                    showButton: false,
                                    placeholder: ""
                                }, null, 8, ["value"]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_unref(UISlider), {
                                        value: brightness.value,
                                        "onUpdate:value": _cache[1] || (_cache[1] = ($event) => ((brightness).value = $event)),
                                        step: 1,
                                        tooltip: false,
                                        min: -100,
                                        max: 100
                                    }, null, 8, ["value"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('adjustments.light.contrast')), 1),
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(_unref(UIInputNumber), {
                                    id: "media-editor-adjustments-contrast-input",
                                    size: "medium",
                                    value: contrast.value,
                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event) => ((contrast).value = $event)),
                                    style: { "width": "58px" },
                                    min: -100,
                                    max: 100,
                                    showButton: false,
                                    placeholder: ""
                                }, null, 8, ["value"]),
                                _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_unref(UISlider), {
                                        value: contrast.value,
                                        "onUpdate:value": _cache[3] || (_cache[3] = ($event) => ((contrast).value = $event)),
                                        step: 1,
                                        tooltip: false,
                                        min: -100,
                                        max: 100
                                    }, null, 8, ["value"])
                                ])
                            ])
                        ]),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('adjustments.color.title')), 1),
                        _createVNode(_unref(UIDivider)),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('adjustments.color.saturation')), 1),
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_unref(UIInputNumber), {
                                    id: "media-editor-adjustment-saturation-input",
                                    size: "medium",
                                    value: saturation.value,
                                    "onUpdate:value": _cache[4] || (_cache[4] = ($event) => ((saturation).value = $event)),
                                    style: { "width": "58px" },
                                    min: -100,
                                    max: 100,
                                    showButton: false,
                                    placeholder: ""
                                }, null, 8, ["value"]),
                                _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_unref(UISlider), {
                                        value: saturation.value,
                                        "onUpdate:value": _cache[5] || (_cache[5] = ($event) => ((saturation).value = $event)),
                                        step: 1,
                                        tooltip: false,
                                        min: -100,
                                        max: 100
                                    }, null, 8, ["value"])
                                ])
                            ])
                        ]),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('adjustments.detail.title')), 1),
                        _createVNode(_unref(UIDivider)),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('adjustments.detail.blur')), 1),
                            _createElementVNode("div", _hoisted_21, [
                                _createVNode(_unref(UIInputNumber), {
                                    id: "media-editor-adjustment-blur-input",
                                    size: "medium",
                                    value: blur.value,
                                    "onUpdate:value": _cache[6] || (_cache[6] = ($event) => ((blur).value = $event)),
                                    min: 0,
                                    max: 100,
                                    style: { "width": "58px" },
                                    showButton: false,
                                    placeholder: ""
                                }, null, 8, ["value"]),
                                _createElementVNode("div", _hoisted_22, [
                                    _createVNode(_unref(UISlider), {
                                        value: blur.value,
                                        "onUpdate:value": _cache[7] || (_cache[7] = ($event) => ((blur).value = $event)),
                                        step: 1,
                                        tooltip: false,
                                        min: 0,
                                        max: 100
                                    }, null, 8, ["value"])
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
